export class Structs {

    xHasChains: boolean;
    xHasRegions: boolean;
    xHasProps: boolean;
    xHasMulStores: boolean;
    xHasMulPCtrs: boolean;

    constructor(obj?: any) {
        this.xHasChains = (obj && obj.xHasChains) || false;
        this.xHasRegions = (obj && obj.xHasRegions) || false;
        this.xHasProps = (obj && obj.xHasProps) || false;
        if(obj){
            this.xHasMulStores = obj.xHasMulStores || false;
        }else{
            this.xHasMulStores = true; //Default is true
        }
        if(obj){
            this.xHasMulPCtrs = obj.xHasMulPCtrs || false;
        }else{
            this.xHasMulPCtrs = true; //Default is true
        }
    }
}
